<script>
    import _ from "lodash";
    import Diagnosis from "../Diagnosis";

    export default {
        methods: {
            coeffRate(data) {
                return data.out.sopMuscleLevel;
            },
            find(data) {
                let display = Diagnosis.data().sopMuscleLevel;
                let vm = this;
                return _.find(display, function (d) {
                    return d.is(vm.coeffRate(data));
                });
            },
            variant(data) {
                return data.out.sopMuscleLevel ? this.find(data).variant : '';
            }
        }
    }
</script>